import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles(() => ({
  header: {
    fontFamily: 'futura-pt, sans-serif;',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '72px',
    lineHeight: '102.2%',
    /* or 74px */
    color: '#FFFFFF',
    zIndex: 1000,
  },
}));

const Header = ({ children }) => {
  const classes = useStyles();

  return <Typography className={classes.header}>{children}</Typography>;
};

export default Header;
